import * as React from "react";

import {FrontendError, MenuDto} from "../services/Client";
import {compose} from "redux";
import {connect} from "react-redux";
import HATEOASClient from "../services/HATEOASClient";
import {renderErrorToast} from "./FeedbackMessageUtils";
import {selectBaseLinks, selectClient} from "../redux/selectors";
import {IReduxState} from "../redux/IReduxState";

interface IOwnProps { }

interface IErrorBoundaryState {
    hasError: boolean;
}

interface IMapStateToProps {
    client: HATEOASClient;
    baseLinks?: MenuDto;
}

interface IErrorBoundaryProps extends IOwnProps, IMapStateToProps {}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error: Error) {
        const timestamp = Date.now();
        if (this.props.baseLinks) {
            const dto = {errorType: error.name, timestamp: new Date(timestamp).toString(), stack: error.stack ? error.stack : "Empty stack"} as FrontendError;

            if (this.props.client.POST_error(this.props.baseLinks).canExecute()) {
                this.props.client.POST_error(this.props.baseLinks).execute(dto)
                    .then(() => {
                        this.setState(
                            {hasError: true});
                        renderErrorToast({
                            message: "ERRORS:UNEXPECTED_ERROR",
                            details: error.message,
                            timestamp,
                        });
                    })
                    .catch((reason: any) => {
                        this.setState({hasError: true});
                        if (error.stack) {
                            error.message = error.stack;
                        }
                        renderErrorToast({
                            message: "ERRORS:UNEXPECTED_ERROR",
                            details: reason,
                            timestamp,
                        });
                        renderErrorToast({
                            message: "UNEXPECTED_ERROR",
                            details: error,
                            timestamp,
                        });
                    });
            }
        } else {
            this.setState({hasError: true});
            renderErrorToast({
                message: "ERRORS:UNEXPECTED_ERROR",
                details: error.message,
                timestamp,
            });
        }
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        return <></>;
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
});

export default compose<React.ComponentType<IOwnProps>>(
    connect<IMapStateToProps>(mapStateToProps)
)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/utils/ErrorBoundary.tsx